import styled from "styled-components";

export const MenuContainer = styled.div(({ theme }) => ({
    position: "absolute",
    zIndex: "1",
    background: theme.colorMode === "light" ? "#FFFBF7" : theme.colors.dark.canvas_Primary,
    height: "100%",
}));

export const BackIcon = styled.div(({ theme }) => ({
    width: "30px",
    height: "30px",
    flexShrink: 0,
    position: "absolute",
    top: "30px",
    left: "20px",
    background: theme.colors[theme.colorMode].text_disabled,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

export const ErrorContainer = styled.div`
    width: 100vw;
`;

export const OverLayLoader = styled("div")(({ theme }) => ({
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: theme.colors[theme.colorMode].canvas_Primary,
}));
